import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import {
  getTouchedFromSchema,
  isInvalid,
  touchFieldsFromErrors,
} from "../utils/forms";
import SelectField from "./controls/SelectField";
import AmmountField from "./controls/AmmountField";
import { LineaVertidoSchema } from "../data/LineaVertisoSchema";
import PointField from "./controls/PointField";
import QuestionField from "./controls/QuestionField";
import ArrayField from "./controls/ArrayField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

import { CaracterizacionEfluenteForm } from "./CaracterizacionEfluenteForm";
import { DestinoVuelco, PeriodicidadVuelco } from "../utils/enums";

export function LineaVertidoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  unidadPeriodoMuestreo,
  unidadHorasVuelcoSemanal,
  unidadHorasVuelcoDiario,
  unidadHorasVuelcoMensual,
  unidadHorasVuelcoDiscontinuo,
  unidadCaudalMedioSemanal,
  unidadCaudalMedioDiario,
  unidadCaudalMedioMensual,
  unidadCaudalMedioDiscontinuo,
  unidadCaudalMedio,
  destinosVertido,
  periodicidadesVuelco,
  unidadCaudalPico,
  unidadCaudalTeorico,
  prestadores,
  subcuencas,
  contaminantes,
  tiposMuestreo,
  disabled,
}) {
  const { t } = useTranslation();
  const initialTouched =
    page >= 0 ? getTouchedFromSchema(value, LineaVertidoSchema) : {};
  const handleNombreChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleDestinoChange = (form) => (event) => {
    const destino = event.target.value;
    if (
      destino.codigo !== DestinoVuelco.SUPERFICIAL &&
      !!form.values.subcuenca &&
      form.values.subcuenca !== null
    ) {
      form.setFieldValue("subcuenca", null, false);
    }
    if (
      destino.codigo !== DestinoVuelco.CLOACAL &&
      !!form.values.prestador &&
      form.values.prestador !== null
    ) {
      form.setFieldValue("prestador", null, false);
    }
    if (
      [DestinoVuelco.SUPERFICIAL, DestinoVuelco.SUELO].indexOf(destino.codigo) <
        0 &&
      !!form.values.ubicacion &&
      form.values.ubicacion !== null
    ) {
      form.setFieldValue("ubicacion", null, false);
    }
    form.handleChange(event);
  };
  const handlePeriodicidadChange = (form) => (event) => {
    const periodicidad = event.target.value;
    if (periodicidad.codigo === PeriodicidadVuelco.PERMANENTE) {
      form.setFieldValue(
        "horasVuelco",
        {
          magnitud: 24,
          unidad: unidadHorasVuelcoDiario,
        },
        false,
      );
    } else {
      form.setFieldValue(
        "horasVuelco",
        { magnitud: 0, unidad: selectUnidadHoras(periodicidad) },
        false,
      );
    }
    form.handleChange(event);
  };
  const handleHorasVuelcoChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handlePrestadorChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleSubcuencaChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCaudalMedioChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCaudalPicoChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCaudalTeoricoChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleUbicacionChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleUbicacionCTMChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleConPermisoVuelcoChange = (form) => (event) => {
    form.setFieldValue("permisoVuelco", null, false);
    form.handleChange(event);
  };
  const handlePermisoVuelcoChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCaracterizacionChange = (form) => (event) => {
    form.handleChange(event);
  };
  const selectUnidadHoras = (periodicidad) => {
    switch (periodicidad?.codigo) {
      case PeriodicidadVuelco.SEMANAL:
        return unidadHorasVuelcoSemanal;
      case PeriodicidadVuelco.DIARIO:
        return unidadHorasVuelcoDiario;
      case PeriodicidadVuelco.MENSUAL:
        return unidadHorasVuelcoMensual;
      case PeriodicidadVuelco.DISCONTINUO:
        return unidadHorasVuelcoDiscontinuo;
      case PeriodicidadVuelco.PERMANENTE:
        return unidadHorasVuelcoDiario;
      default:
        return unidadHorasVuelcoDiario;
    }
  };
  const selectUnidadCuadal = (periodicidad) => {
    switch (periodicidad?.codigo) {
      case PeriodicidadVuelco.SEMANAL:
        return unidadCaudalMedioSemanal;
      case PeriodicidadVuelco.DIARIO:
        return unidadCaudalMedioDiario;
      case PeriodicidadVuelco.MENSUAL:
        return unidadCaudalMedioMensual;
      case PeriodicidadVuelco.DISCONTINUO:
        return unidadCaudalMedioDiscontinuo;
      case PeriodicidadVuelco.PERMANENTE:
        return unidadCaudalMedioDiario;
      default:
        return unidadCaudalMedio;
    }
  };
  // TODO: Cuando la periodicidad del vuelco es permanente tiene que fijar 24hs/dia como valor en cantidad horas vuelco
  // TODO: Validar que las horas/dias y dias/semana, etc no superen las relaciones de estas unidades
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnMount={page >= 0}
      initialTouched={initialTouched}
      validationSchema={LineaVertidoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(form) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("lineaVertidoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <Grid>
                <Row>
                  <Col>
                    <TextField
                      id="lineaVertido_nombre"
                      name="nombre"
                      label={t("lineaVertido.nombre")}
                      value={form.values?.nombre}
                      onChange={handleNombreChange(form)}
                      isInvalid={isInvalid("nombre", form)}
                      error={t(form.errors.nombre)}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <SelectField
                      id="lineaVertido_destino"
                      name="destino"
                      label={t("lineaVertido.destino")}
                      value={form.values?.destino}
                      onChange={handleDestinoChange(form)}
                      options={destinosVertido}
                      labelAttr="nombre"
                      valueAttr="codigo"
                      emptyLabel="..."
                      isInvalid={isInvalid("destino", form)}
                      error={t(form.errors.destino)}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <SelectField
                      id="lineaVertido_periodicidad"
                      name="periodicidad"
                      label={t("lineaVertido.periodicidad")}
                      value={form.values?.periodicidad}
                      onChange={handlePeriodicidadChange(form)}
                      options={periodicidadesVuelco}
                      labelAttr="nombre"
                      valueAttr="codigo"
                      emptyLabel="..."
                      isInvalid={isInvalid("periodicidad", form)}
                      error={t(form.errors.periodicidad)}
                      disabled={disabled}
                    />
                  </Col>
                  <Col lg={4}>
                    <AmmountField
                      id="lineaVertido_horasVuelco"
                      name="horasVuelco"
                      label={t("lineaVertido.horasVuelco")}
                      value={form.values?.horasVuelco}
                      onChange={handleHorasVuelcoChange(form)}
                      unit={selectUnidadHoras(form.values?.periodicidad)}
                      isInvalid={isInvalid("horasVuelco", form)}
                      error={t(form.errors.horasVuelco)}
                      disabled={
                        disabled ||
                        form.values.periodicidad?.codigo ===
                          PeriodicidadVuelco.PERMANENTE
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <AmmountField
                      id="lineaVertido_caudalMedio"
                      name="caudalMedio"
                      label={t("lineaVertido.caudalMedio")}
                      value={form.values?.caudalMedio}
                      onChange={handleCaudalMedioChange(form)}
                      unit={selectUnidadCuadal(form.values?.periodicidad)}
                      isInvalid={isInvalid("caudalMedio", form)}
                      error={t(form.errors.caudalMedio)}
                      disabled={disabled}
                    />
                  </Col>
                  <Col lg={4}>
                    <AmmountField
                      id="lineaVertido_caudalPico"
                      name="caudalPico"
                      label={t("lineaVertido.caudalPico")}
                      value={form.values?.caudalPico}
                      onChange={handleCaudalPicoChange(form)}
                      unit={unidadCaudalPico}
                      isInvalid={isInvalid("caudalPico", form)}
                      error={t(form.errors.caudalPico)}
                      disabled={disabled}
                    />
                  </Col>
                  <Col lg={4}>
                    <AmmountField
                      id="lineaVertido_caudalTeorico"
                      name="caudalTeorico"
                      label={t("lineaVertido.caudalTeorico")}
                      value={form.values?.caudalTeorico}
                      onChange={handleCaudalTeoricoChange(form)}
                      unit={unidadCaudalTeorico}
                      isInvalid={isInvalid("caudalTeorico", form)}
                      error={t(form.errors.caudalTeorico)}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <SelectField
                      id="lineaVertido_prestador"
                      name="prestador"
                      label={t("lineaVertido.prestador")}
                      value={form.values?.prestador}
                      onChange={handlePrestadorChange(form)}
                      options={prestadores}
                      labelAttr="nombre"
                      valueAttr="codigo"
                      emptyLabel="..."
                      isInvalid={isInvalid("prestador", form)}
                      error={t(form.errors.prestador)}
                      disabled={
                        form.values?.destino?.codigo !== "CLOACAL" || disabled
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <SelectField
                      id="lineaVertido_subcuenca"
                      name="subcuenca"
                      label={t("lineaVertido.subcuenca")}
                      value={form.values?.subcuenca}
                      onChange={handleSubcuencaChange(form)}
                      options={subcuencas}
                      labelAttr="nombre"
                      valueAttr="codigo"
                      emptyLabel="..."
                      isInvalid={isInvalid("subcuenca", form)}
                      error={t(form.errors.subcuenca)}
                      disabled={
                        form.values?.destino?.codigo !== "SUPERFICIAL" ||
                        disabled
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <PointField
                      id="lineaVertido_ubicacionCTM"
                      name="ubicacionCTM"
                      label={t("lineaVertido.ubicacionCTM")}
                      value={form.values?.ubicacionCTM}
                      onChange={handleUbicacionCTMChange(form)}
                      isInvalid={isInvalid("ubicacionCTM", form)}
                      error={t(form.errors.ubicacionCTM)}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <PointField
                      id="lineaVertido_ubicacion"
                      name="ubicacion"
                      label={t("lineaVertido.ubicacion")}
                      value={form.values?.ubicacion}
                      onChange={handleUbicacionChange(form)}
                      isInvalid={isInvalid("ubicacion", form)}
                      error={t(form.errors.ubicacion)}
                      disabled={
                        ["SUPERFICIAL", "SUELO"].indexOf(
                          form.values?.destino?.codigo,
                        ) < 0 || disabled
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <QuestionField
                      id="lineaVertido_conPermisoVuelco"
                      name="conPermisoVuelco"
                      label={t(
                        `lineaVertido.conPermisoVuelco.${form.values?.destino?.codigo}`,
                      )}
                      value={form.values?.conPermisoVuelco}
                      onChange={handleConPermisoVuelcoChange(form)}
                      isInvalid={isInvalid("conPermisoVuelco", form)}
                      error={t(form.errors.conPermisoVuelco)}
                      disabled={!form.values?.destino?.codigo || disabled}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextField
                      id="lineaVertido_permisoVuelco"
                      name="permisoVuelco"
                      label={t(
                        `lineaVertido.permisoVuelco.${form.values?.destino?.codigo}`,
                      )}
                      value={form.values?.permisoVuelco}
                      onChange={handlePermisoVuelcoChange(form)}
                      isInvalid={isInvalid("permisoVuelco", form)}
                      error={t(form.errors.permisoVuelco)}
                      disabled={
                        !form.values?.destino?.codigo ||
                        !form.values?.conPermisoVuelco ||
                        disabled
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ArrayField
                      id="lineaVertido_caracterizacion"
                      name="caracterizacion"
                      label={t("lineaVertido.caracterizacion")}
                      value={form.values?.caracterizacion}
                      onChange={handleCaracterizacionChange(form)}
                      isInvalid={isInvalid("caracterizacion", form)}
                      error={t(form.errors.caracterizacion)}
                      disabled={disabled}
                    >
                      {({
                        value,
                        append,
                        remove,
                        select,
                        replace,
                        selectedItem,
                        selectedIndex,
                        disabled,
                      }) => (
                        <CaracterizacionEfluenteForm
                          value={value}
                          page={selectedIndex}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          tiposMuestreo={tiposMuestreo}
                          unidadPeriodoMuestreo={unidadPeriodoMuestreo}
                          unidadCaudalMedio={unidadCaudalMedio}
                          contaminantes={contaminantes}
                          disabled={disabled}
                        />
                      )}
                    </ArrayField>
                  </Col>
                </Row>
              </Grid>
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("lineaVertidoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("lineaVertidoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("lineaVertidoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    form.validateForm().then((errors) => {
                      if (touchFieldsFromErrors(errors, form)) {
                        return;
                      }
                      form.submitForm();
                    });
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("lineaVertidoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
